const ProductsServicesContent = (content, pickProductName, addons) => {
  return addons.map((addon) => {
    // TODO Temporary mapping for Odoo API testing.
    addon.productId = addon.defaultCode
    addon.translationKey = `translation_addon_${addon.defaultCode}`
    return {
      productId: addon.productId,
      text: {
        title: content[`${addon.translationKey}_title`] || pickProductName(addon),
        shorttext: content[`${addon.translationKey}_shorttext`],
        subtexts: [
          {
            subtitle: content[`${addon.translationKey}_subtitle1`],
            paragraph: content[`${addon.translationKey}_paragraph1`],
          },
          {
            subtitle: content[`${addon.translationKey}_subtitle2`],
            paragraph: content[`${addon.translationKey}_paragraph2`],
          },
        ],
        listitems: [
          content[`${addon.translationKey}_listitem1`],
          content[`${addon.translationKey}_listitem2`],
        ],
      },
      prices: {
        priceInclVAT: addon.priceInclVAT,
        priceExclVAT: addon.priceExclVAT,
      },
      translationKey: addon.translationKey,
    }
  })
}

export default ProductsServicesContent
